import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { CstmPagination } from "../../../../components/Common/Common";
import { Link } from "react-router-dom";

// img
import user from "../../../../Assets/images/user.png";
import {
  GET_DRIVERS_PAYOUT_LIST,
  GET_PAYMENT_METHODS,
  GET_TRANSACTION_HISTORY,
  GET_WALLET_INFO,
} from "../../../../services/ApiCalls";
import { toast } from "react-toastify";
import TransactionTable from "../../../../components/transactionHistory/TransactionTable";
import SendMoneyCard from "./SendMoneyCard";
import { moneyTransFerType } from "../../../../utilities/const";

const Wallet = () => {
  const [data, setData] = useState([]);
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [loader, setLoader] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [banks, setBanks] = useState([]);
  const [body, setBody] = useState({
    page: 1,
    limit: 10,
    orderBy: "createdAt",
    order: -1,
    search: "",
    status: "all",
  });


  const getData = async (body) => {
    setLoader(true);
    try {
      const res = await Promise.all([
        GET_WALLET_INFO(body),
        GET_PAYMENT_METHODS(),
        GET_TRANSACTION_HISTORY(body),
      ]);

      if (res[0]?.data?.status === "success") {
        setData(res[0]?.data?.data?.walletBalance);
      } else {
        toast.error(res[0]?.data?.message);
      }

      if (res[1]?.data?.status === "success") {
        setBanks(res[1]?.data?.data);
      } else {
        toast.error(res[1]?.data?.message);
      }

      if (res[2]?.data?.status === "success") {
        setTransactionHistory(res[2]?.data?.data.fixedTransactionData);
        setTotalCount(res[2]?.data?.data?.totalCount);
      } else {
        toast.error(res[1]?.data?.message);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      toast.error("something went wrong");
      setLoader(false);
    }
  };

  useEffect(() => {
    getData(body);
  }, [body.page]);

  return (
    <>
      <section className="wallet py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="sectionHeader mb-3">
                <h3 className="m-0 fw-sbold themeBlue">Wallet</h3>
              </div>
              <div className="bg-white p-3">
                <Row className="">
                  <Col lg="4" className="my-2 align-self-center">
                    <div className="d-flex align-items-center gap-10">
                      <div className="icn me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="50"
                          height="43"
                          viewBox="0 0 50 43"
                          fill="none"
                        >
                          <path
                            d="M48.5354 19.7724H47.0629V10.8548C47.0629 10.046 46.4071 9.39021 45.5983 9.39021H43.1651V1.46461C43.1651 0.655756 42.5094 0 41.7005 0H6.15977C2.76323 0 0 2.76323 0 6.15967V34.6857C0 39.1985 3.67149 42.8699 8.18415 42.8699H45.5983C46.4071 42.8699 47.0629 42.2141 47.0629 41.4053V34.4405H48.5354C49.3442 34.4405 50 33.7848 50 32.9759V21.237C50 20.4281 49.3442 19.7724 48.5354 19.7724ZM6.15977 2.92913H40.2359V9.39021H6.15977C4.37851 9.39021 2.92922 7.94103 2.92922 6.15967C2.92922 4.37841 4.37851 2.92913 6.15977 2.92913ZM44.1336 39.9408H8.18415C5.28666 39.9408 2.92922 37.5834 2.92922 34.6857V11.4015C3.86911 11.9829 4.97568 12.3195 6.15977 12.3195H44.1336V19.7725H38.2969C34.2528 19.7725 30.9627 23.0626 30.9627 27.1066C30.9627 31.1506 34.2528 34.4407 38.2969 34.4407H44.1336V39.9408ZM47.0708 31.5114H38.2969C35.868 31.5114 33.8919 29.5354 33.8919 27.1065C33.8919 24.6776 35.868 22.7016 38.2969 22.7016H47.0708V31.5114Z"
                            fill="#C11111"
                          />
                        </svg>
                      </div>
                      <div className="content">
                        <h6 className="m-0 themeBlue pb-2 fw-sbold">
                          Main Balance
                        </h6>
                        <h6 className="m-0 text-muted fw-sbold">
                          {data?.balance}
                        </h6>
                      </div>
                    </div>
                  </Col>
                  <Col lg="4" className="my-2">
                    <div className="cardCstm border rounded p-3">
                      <div
                        className="top pb-2 text-center"
                        style={{ borderBottom: "3px solid #DC1919" }}
                      >
                        <p className="m-0 fw-sbold">
                          Send money wallet to account
                        </p>
                      </div>
                      <div className="content">
                        <SendMoneyCard
                          type={moneyTransFerType.walletToBank}
                          banks={banks}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg="4" className="my-2">
                    <div className="cardCstm border rounded p-3">
                      <div
                        className="top pb-2 text-center"
                        style={{ borderBottom: "3px solid #DC1919" }}
                      >
                        <p className="m-0 fw-sbold">
                          Send money account to wallet
                        </p>
                      </div>
                      <div className="content">
                        <SendMoneyCard
                          type={moneyTransFerType.BankToWallet}
                          banks={banks}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            <TransactionTable
              data={transactionHistory}
              body={body}
              setBody={setBody}
              loader={loader}
              reFetch={getData}
              totalCount={totalCount}
            />
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Wallet;
